<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import config from './configs'

/*
|---------------------------------------------------------------------
| Main Application Component
|---------------------------------------------------------------------
*/
export default {
  head: {
    link: [
      // adds config/icons into the html head tag
      ...config.icons.map((href) => ({ rel: 'stylesheet', href }))
    ]
  }
}
</script>
<style lang="scss">
.button-default-width {
    width: 100px !important;
}

.noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

/* width */
::-webkit-scrollbar {
    width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 4px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: var(--v-secondary-base);
    border-radius: 4px;
}

.color-primary {
    color: var(--v-primary-base);
}

.color-secondary {
    color: var(--v-secondary-base);
}

.color-error {
    color: var(--v-error-base);
}

.color-black {
    color: black !important;
}

.color-accent {
    color: var(--v-accent-base);
}

.clickable-simple {
    cursor: pointer;
}

.underline-simple {
    text-decoration: underline;
}

.one-page-height {
    max-height: 82vh;
}

.required-asterisk label:after {
    content: ' *';
    color: var(--v-error-base);
}

.max-width {
    width: 100% !important;
}
</style>
